import React from "react";
import { useParams } from "react-router-dom";
import blogdata from "./blogdata"; // Adjust path if needed
import "./blog.css";

function BlogPost() {
  const { slug } = useParams();
  const blog = blogdata.find((item) => item.slug === slug);

  if (!blog) return <h2 style={{ padding: "2rem" }}>Blog post not found</h2>;

  return (
    <div className="blog-post-page">
      {/* Heading at the top */}
      <h1 className="blog-heading">{blog.heading || blog.name}</h1>

      {/* Image */}
      <div className="blog-post-image">
        <img src={blog.img} alt={blog.name} />
      </div>

      {/* Quote below the image */}
      {blog.imageQuote && <p className="image-quote">{blog.imageQuote}</p>}

      {/* Main content */}
      <div className="blog-post-content">
        {blog.paragraphs
          ? blog.paragraphs.map((para, i) => <p key={i}>{para}</p>)
          : blog.intro && <p>{blog.intro}</p>}
      </div>

      {/* Optional closing quote and note */}
      {blog.closingQuote && (
        <blockquote className="blog-quote">{blog.closingQuote}</blockquote>
      )}

      {blog.closingNote && <p className="closing-note">{blog.closingNote}</p>}
    </div>
  );
}

export default BlogPost;
